if (!customElements.get('findsy-bundle-select')) {
  customElements.define(
    'findsy-bundle-select',
    class FindsyBundleSelect extends HTMLElement {
      constructor() {
        super();
        this.quantityInput = document.getElementById(this.dataset.quantityInput);
        this.sectionId = this.dataset.sectionId;
        this.submitButton = this.sectionId
          ? document.getElementById(`ProductSubmitButton-${this.sectionId}`)
          : null;
        this.stickySubmitButton = this.sectionId
          ? document.getElementById(`FindsyStickySubmit-${this.sectionId}`)
          : null;
        this.changeEvent = new Event('change', { bubbles: true });
        this.variantChangeUnsubscriber = undefined;
        this.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        this.syncQuantity();
        this.updateCta();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (String(event?.data?.sectionId) !== String(this.sectionId)) return;
            // Dawn's own product-info.js resets the quantity input to its
            // variant's minimum (setQuantityBoundries) as part of this same
            // variant-change pipeline, before this subscriber ever runs -
            // re-assert the selected tier's quantity so a variant switch can
            // never leave the UI saying "2/3" while the form would submit 1.
            this.syncQuantity();
            this.updateCta();
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      onChange(event) {
        if (event.target.type !== 'radio') return;
        this.syncQuantity();
        this.updateCta();
      }

      syncQuantity() {
        if (!this.quantityInput) return;
        const checked = this.querySelector('input[type="radio"]:checked');
        if (!checked) return;

        if (this.quantityInput.value !== checked.value) {
          this.quantityInput.value = checked.value;
          this.quantityInput.dispatchEvent(this.changeEvent);
        }
      }

      // Puts the selected tier's already-rendered total (data-total-formatted,
      // sourced from the exact same Liquid money math as the visible row span
      // in findsy-bundle-selector.liquid - never recomputed here) into the Add
      // to cart label, on both the primary button and (if present) the sticky
      // one. assets/findsy.js runs its own variantChange subscribers first
      // (registered earlier, in layout/theme.liquid's <head>) to restore
      // Dawn's per-unit/sold-out/unavailable text on each from the freshly
      // fetched section HTML - including FindsyStickyCart, which mirrors the
      // primary button's label onto the sticky one. This runs after both and
      // only overwrites a button with the bundle total when that specific
      // button isn't currently disabled, so a sold-out or unavailable variant
      // always keeps Dawn's canonical text untouched on either button.
      updateCta() {
        const checked = this.querySelector('input[type="radio"]:checked');
        const total = checked?.dataset.totalFormatted;
        const addToCartText = window.variantStrings?.addToCart;
        if (!total || !addToCartText) return;

        [this.submitButton, this.stickySubmitButton].forEach((button) => {
          if (!button || button.hasAttribute('disabled')) return;
          const label = button.querySelector('span');
          if (!label) return;
          label.textContent = `${addToCartText} — ${total}`;
        });
      }
    }
  );
}
